































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PolicyDocuments, { PolicyDocumentMetadata, PolicyPacket } from '@/services/PolicyDocuments';
import * as Sentry from '@sentry/browser';
import { mapGetters } from 'vuex';

@Component({
     name: 'ClientDetails',
})
export default class ClientDetails extends Vue {
     @Prop() private client: any;
     private policyDocs: boolean;
     private error: boolean = false;
     private loading: boolean = true;

     constructor() {
          super();

          this.policyDocs = false;
     }

     get endorsements() {
          return this.client.packet.metadatas.filter(
               meta => meta.documentType === 'Policy - Endorsement Forms',
          );
     }

     get coverage_type(): string {
          let mainRisk = null;
          try {
               mainRisk = this.getMainRisk();
          } catch (e) {
               return e;
          }

          const coverage = mainRisk.type_of_coverage.find(
               c =>
                    c.type === 'Manual-Corporate Liability-Primary' ||
                    c.type === 'Manual-Ancillary Provider-Primary',
          );

          if (coverage.claim_type === 'CM') {
               return 'Claims-Made';
          } else {
               return 'Occurrence';
          }
     }

     get limits(): string {
          let mainRisk = null;
          try {
               mainRisk = this.getMainRisk();
          } catch (e) {
               return e;
          }

          const coverage = mainRisk.type_of_coverage.find(
               c =>
                    c.type === 'Manual-Corporate Liability-Primary' ||
                    c.type === 'Manual-Ancillary Provider-Primary',
          );

          return coverage.each + ' / ' + coverage.aggregate;
     }

     get prioracts(): string {
          let mainRisk = null;

          try {
               mainRisk = this.getMainRisk();
          } catch (e) {
               return e;
          }

          const coverage = mainRisk.type_of_coverage.find(
               c =>
                    c.type === 'Manual-Corporate Liability-Primary' ||
                    c.type === 'Manual-Ancillary Provider-Primary',
          );

          return coverage.retroactive_date;
     }

     private async downloadPolicyDocument(metadata) {
          const url = await PolicyDocuments.getPolicyDocumentLocation(
               metadata.policyNumber,
               metadata.id,
          );
          window.location = url;
     }

     private openPolicyDocs() {
          this.policyDocs = !this.policyDocs;
     }

     private getMainRisk() {
          const mainRiskIndex = Object.keys(this.client.risks).find(
               risk =>
                    'main_risk' in this.client.risks[risk] &&
                    this.client.risks[risk].main_risk === 'Y',
          );

          if (mainRiskIndex === undefined) {
               throw new Error('Unknown');
          }

          const mainRisk = this.client.risks[mainRiskIndex];

          return mainRisk;
     }
}
